export const NOTIFY_LOCALE = {
    title: 'System Information'
};
